var React = require('react');
var BaseClassComponent = require('../../shared/base.jsx');

class PdfComponent extends BaseClassComponent {
    constructor(props) {
        super(props);
        let fileName = '';
        if (props.customFieldValues && props.customFieldValues.Values && props.customFieldValues.Values.length > 0) {
            fileName = props.customFieldValues.Values[0].split('/').pop().substr(47);
        }
        this.state = {
            fileName: fileName
        };

        this.onPDFChange = this.onPDFChange.bind(this);
    }

    onPDFChange(e) {
        var _this = this;
        let files = e.target.files;
        this.setState({
            fileName: e.target.files[0].name
        }, () => {
            let reader = new FileReader();
            reader.onload = r => {
                    _this.props.onCustomFileChanged(_this.props.customFieldDefinition, r.target.result, _this.state.fileName);                    
                };
                reader.readAsDataURL(files[0]);
            }
        )
    }

    render() {
        let css = "input-upload ";
        if (this.props.customFieldDefinition.IsMandatory) {
            css += "required";
        }
        return (            
            <div className="input-container">
                <div className={css}>
                    <span className="custom-image">{this.props.customFieldDefinition.Name}</span>
                    <div className="input-flex">
                        <input type="text" className="input-text custom-image-text isPdf" name="custom_image" placeholder="Browse..." value={this.state.fileName} />
                        <div className="btn-upload btn" style={{ borderRadius: "0px" }}>
                            <input onChange={this.onPDFChange} type="file" accept="application/pdf" />
                            Upload
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

module.exports = PdfComponent;